export interface GetManyResponse<T> {
  data: T[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

export const extractResponseData = <T>(response: GetManyResponse<T> | T[]): T[] =>
  Array.isArray(response) ? response : (response?.data ?? []);
